import { numeral } from '../numeral';

numeral.register('format', 'currency', {
	regexps: {
		format: /(\$)/
	},

	format(value: number, format: string, roundingFunction: (x: number) => number) {
		const locale = numeral.locales[numeral.options.currentLocale];
		const { _ } = numeral;

		const symbols = {
			before: format.match(/^([+|\-|(|\s|$]*)/)![0],
			after: format.match(/([+|\-|)|\s|$]*)$/)![0]
		};

		let symbol: string;

		// strip format of spaces and $
		format = format.replace(/\s?\$\s?/, '');

		// format the number
		let output = _.numberToFormat(value, format, roundingFunction);

		// update the before and after based on value
		if (value >= 0) {
			symbols.before = symbols.before.replace(/[-(]/, '');
			symbols.after = symbols.after.replace(/[-)]/, '');
		} else if (value < 0 && !symbols.before.includes('-') && !symbols.before.includes('(')) {
			symbols.before = `-${symbols.before}`;
		}

		// loop through each before symbol
		for (let i = 0; i < symbols.before.length; i++) {
			symbol = symbols.before[i];

			switch (symbol) {
				case '$':
					output = _.insert(output, locale.currency.symbol, i);
					break;
				case ' ':
					output = _.insert(output, ' ', i + locale.currency.symbol.length - 1);
					break;
			}
		}

		// loop through each after symbol
		for (let i = symbols.after.length - 1; i >= 0; i--) {
			symbol = symbols.after[i];

			switch (symbol) {
				case '$':
					output =
						i === symbols.after.length - 1
							? output + locale.currency.symbol
							: _.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
					break;
				case ' ':
					output =
						i === symbols.after.length - 1
							? `${output} `
							: _.insert(
									output,
									' ',
									-(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1)
									// tslint:disable-next-line:indent
							  );
					break;
			}
		}

		return output;
	}
});
